export default __webpack_public_path__ + "static/media/view.31ac75cf.svg";